import { render, staticRenderFns } from "./TaskNewReport.vue?vue&type=template&id=167e6ace&scoped=true"
import script from "./TaskNewReport.vue?vue&type=script&lang=js"
export * from "./TaskNewReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e6ace",
  null
  
)

export default component.exports